// flow weak

/* eslint no-console:0 */
/* eslint consistent-return:0 */

/*
  imports
 */
import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getSessionPlanData, postSessionPlanData, deleteSessionPlanData,
  putSessionPlanData
}                           from '../../services/API';
import {
  fetchMockstatsTableData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

/*
  constants
 */
const REQUEST_SESSION_PLAN_DATA   = 'REQUEST_SESSION_PLAN_DATA';
const RECEIVED_SESSSION_PLAN_DATA  = 'RECEIVED_SESSSION_PLAN_DATA';
const ERROR_SESSION_PLAN_DATA     = 'ERROR_SESSION_PLAN_DATA';


let sessionPlan = {
  isFetching: false,
  // headers:     [],
  data:   null,
  // requested_venue_id: 0,
  // venue_id: -1,
  time:       null
};

/*
  reducer
 */
  let initialStateCopy = {};
  for (var property in appConfig.sessionPlans.data) {
      // console.log(property);
      // console.log(appConfig.sessionPlans.data.hasOwnProperty(property));
      // console.log(Object.getOwnPropertyNames(appConfig.sessionPlans.data));
    if (appConfig.sessionPlans.data.hasOwnProperty(property) && property != "API") {
        initialStateCopy[property] = Object.assign({}, sessionPlan);
        initialStateCopy[`reset::${property}`] = Object.assign({}, sessionPlan);
    }
  } 
  const initialState = initialStateCopy;
  // const initialState = sessionPlan;

export default function sessionPlan(state = initialState, action) {
  console.log(initialState);
  console.log("Session plan call - API");
  console.log(appConfig.sessionPlans.data);
  console.log(action);
  let data = initialState;
  // return state
  switch (action.type) {
  case 'CHANGE_LOCATION_FOR_SESSION_PLAN':
    console.log("SH - REQUEST_LOCATION_CHANGE");
    console.log(state);
    data[action.name].requested_venue_id = action.selectedLocation;
    return Object.assign({}, state, data);
  case 'REFRESH_SESSION_PLAN_DATA':
    console.log("SH- REFRESH_SESSION_PLAN_DATA");
    fetchSessionPlanDataIfNeeded(action.venue_id,action.name);
    return state;        
  case 'REQUEST_SESSION_PLAN_DATA':
    console.log("SH - REQUEST_SESSION_PLAN_DATA data");
    console.log(state);
    console.log(action);
    console.log(data);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    return Object.assign({}, state, data);
  case 'RECEIVED_SESSSION_PLAN_DATA':
    console.log("SH - RECEIVED_SESSSION_PLAN_DATA data");
    console.log(action);
    console.log(state);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    // data[action.name].headers = action.headers;
    data[action.name].data = action.data;
    // data[action.name].venue_id = action.venue_id;
    let newstate = Object.assign({}, state, data);
    console.log(newstate);
    return newstate;
  case 'ERROR_SESSION_PLAN_DATA':
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    data[action.name].headers = [];
    data[action.name].data = [[]];
    //To avoid api loop
    //Stop at first api error.
    data[action.name].venue_id = state[action.name].requested_venue_id;    
    return Object.assign({}, state, data);
  default:
    return state;
  }
}


/*
  action creators
 */
// export function fetchSessionPlanDataIfNeeded(id=0,name) {
export function fetchSessionPlanDataIfNeeded(name, query) {
    console.log("SP ifNeeded");
    console.log(query);
  return (
    dispatch, 
    getState
  ) => {
    // if (shouldFetchSessionPlanData(getState(),name)) {
    if (shouldFetchSessionPlanData(getState(), name) || name.split("::")[0] == "reset") {
      // return dispatch(fetchSessionPlanData(id,name));
      return dispatch(fetchSessionPlanData(name, query));
    }
  };
}
export function throwSessionPlanDataHandler(name, payload) {
    console.log("SP if throw handler");
  return (
    dispatch, 
    getState
) => dispatch(throwSessionPlanData(name, payload));
}
export function destroySessionPlanDataHandler(name, payload) {
    console.log("SP if destroy handler");
  return (
    dispatch, 
    getState
) => dispatch(destroySessionPlanData(name, payload));
}

export function editSessionPlanDataHandler(name, payload) {
    console.log("SP if edit handler");
  return (
    dispatch, 
    getState
) => dispatch(editSessionPlanData(name, payload));
}

function requestSessionPlanData(name,time = moment().format()) {
  return {
    type:       REQUEST_SESSION_PLAN_DATA,
    isFetching: true,
    time,name
  };
}
function receivedSessionPlanData(data,name, time = moment().format()) {
    console.log("receivedSessionPlanData");
    console.log(data);
  return {
    type:       RECEIVED_SESSSION_PLAN_DATA,
    isFetching: false,
    // headers:     [...data.headers],
    data:   data,
    // venue_id:   data.venue_id,
    time,name
  };
}
function errorSessionPlanData(error,name, time = moment().format()) {
  return {
    type:       ERROR_SESSION_PLAN_DATA,
    isFetching: false,
    error,
    time,name
  };
}
function fetchSessionPlanData(name, query) {
    // console.log(id);
    console.log(name);
    console.log(query);
    console.log("SH fetchSessionPlanData");
  return dispatch => {
    dispatch(requestSessionPlanData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionPlanData(null,name.split("::")[1] ));
    } else if(name == "sections" && query!= ""){
      getSessionPlanData(name, `?q=${query}`)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
    } else if(name == "get" && query!= ""){
      getSessionPlanData(name, query)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
    } else if(name == "listing" || name == "find"){
        console.log("find session plan check in reducer")
        var query_params = "?"
        if (query != null){
            Object.keys(query).map(function(key, index) {
                query_params = query_params + `${key}=${query[key]}&`;
            });
        }
        
      getSessionPlanData(name, query_params)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
    } else if(name != "" && query!= ""){
      getSessionPlanData(name, `?game_type_id=${query}`)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
      }else{
        //Redux data clearing request.
        dispatch(receivedSessionPlanData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function throwSessionPlanData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH throwSessionPlanData");
  return dispatch => {
    dispatch(requestSessionPlanData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionPlanData(null,name.split("::")[1] ));
    } else if(name != ""){
      postSessionPlanData(name, payload)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
      }else{
        //Redux data clearing request.
        dispatch(receivedSessionPlanData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function destroySessionPlanData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH destroySessionPlanData");
  return dispatch => {
    dispatch(requestSessionPlanData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionPlanData(null,name.split("::")[1] ));
    }
    else if(name != ""){
      deleteSessionPlanData(name, payload)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
    }
    else{
        //Redux data clearing request.
        dispatch(receivedSessionPlanData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function editSessionPlanData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH editSessionPlanData");
  return dispatch => {
    dispatch(requestSessionPlanData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionPlanData(null,name.split("::")[1] ));
    }
    else if(name != ""){
      putSessionPlanData(name, payload)
        .then(
          data => dispatch(receivedSessionPlanData(data,name))
        )
        .catch(
          error => dispatch(errorSessionPlanData(error,name))
        );      
    }
    else{
        //Redux data clearing request.
        dispatch(receivedSessionPlanData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}

function shouldFetchSessionPlanData(state,name) {
  const spStore = state.sessionPlan[name];
  console.log(state);
  if (spStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/sessionPlan.js